import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useAccessContext } from '../contexts/AccessProvider';

const PremiumModal = () => {
  const navigate = useNavigate();
  const { isPremiumModalOpen, hidePremiumModal, modalMessage } = useAccessContext();

  const handleUpgrade = () => {
    navigate('/app/billing');
  };

  return (
    <Dialog open={isPremiumModalOpen} onClose={hidePremiumModal} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" component="div" sx={{ color: 'error.main' }}>
          Upgrade plan
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ my: 3 }}>
          <Typography variant="body1">{modalMessage}</Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button onClick={hidePremiumModal} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleUpgrade} variant="contained" color="error">
            Upgrade
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PremiumModal;
